import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import MobileSettingsWrapper from './MobileSettingsWrapper.vue';
import MobileConversationFlowsIndex from './Index.vue';
import MobileConversationFlowEditor from './Editor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/mobile-flowbuilder'),
      component: MobileSettingsWrapper,
      children: [
        {
          path: '',
          name: 'mobile_conversation_flows_index',
          component: MobileConversationFlowsIndex,
          meta: {
            featureFlag: FEATURE_FLAGS.MOBILE_CONVERSATION_FLOWS,
            permissions: ['administrator'],
          },
        },
        {
          path: ':flowId',
          name: 'mobile_conversation_flow_editor',
          component: MobileConversationFlowEditor,
          meta: {
            featureFlag: FEATURE_FLAGS.MOBILE_CONVERSATION_FLOWS,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
